module.exports = __webpack_public_path__ + "static/media/6p.feb6344f.jpg";